import { call, select, takeEvery } from 'redux-saga/effects';

import { ACTIVE_VENUE_CHANGED } from 'features/App/App.saga';
import { makePath } from 'helpers/link-generation';
import { selectActiveVenueId } from 'selectors/general';

import { SKU_MODIFIERS_TAB, SKU_TAB_PARAM } from 'features/Sku/Items/useSkuMenuState';

// A modifier group belongs to a single venue, so switching venues mid-editor cannot keep the
// page: land on the new venue's modifier library instead.
export function* handleActiveVenueChange(client, action) {
  const { venueId } = action;
  const activeVenueId = yield select(selectActiveVenueId);

  if (venueId !== activeVenueId) {
    yield call(client.navigate, `${makePath.items(venueId)}?${SKU_TAB_PARAM}=${SKU_MODIFIERS_TAB}`);
  }
}

export function* watchActions(dependencies) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, handleActiveVenueChange, dependencies);
}
